class SensenPredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-sensen-predictive-search]');
    this.form = this.querySelector('form');
    this.abortController = null;

    if (!this.input) return;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 250).bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFocus() {
    const searchTerm = this.getQuery();
    if (searchTerm.length) {
      this.getSearchResults(searchTerm);
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();

    const searchUrl = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection,page,article&resources[options][unavailable_products]=last&section_id=sensen-predictive-search`;

    fetch(searchUrl, { signal: this.abortController.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const sectionContent = doc.querySelector('#shopify-section-sensen-predictive-search');
        const resultsMarkup = sectionContent ? sectionContent.innerHTML : '';
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
      });
  }

  renderSearchResults(resultsMarkup) {
    if (!this.predictiveSearchResults) return;
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.open();
  }

  open() {
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.style.display = 'block';
      this.setAttribute('open', '');
      if (this.input) {
        this.input.setAttribute('aria-expanded', 'true');
      }
      const header = this.closest('.sensen-header-container') || document.querySelector('.sensen-header-container');
      if (header) {
        header.classList.add('is-search-open');
      }
    }
  }

  close() {
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.innerHTML = '';
      this.removeAttribute('open');
      if (this.input) {
        this.input.setAttribute('aria-expanded', 'false');
      }
      const header = this.closest('.sensen-header-container') || document.querySelector('.sensen-header-container');
      if (header) {
        const anyOpen = document.querySelector('sensen-predictive-search[open]');
        if (!anyOpen) {
          header.classList.remove('is-search-open');
        }
      }
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

if (!customElements.get('sensen-predictive-search')) {
  customElements.define('sensen-predictive-search', SensenPredictiveSearch);
}
